import { Stack, useTheme, Modal, Typography, Button, Divider, Box } from '@mui/material';
import { PhoneInput } from '@treedis/tour-loader';
import { useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import AdminAPI from '@/api/TreedisAdminDAO';

export const FinishModal = ({
  isOpen,
  inputClientRect,
  target,
  popupTitle,
  qrEnabled,
  qrTitle,
  smsEnabled,
  smsTitle,
  smsText,
  rtl,
  ratingClientRect,
}: {
  isOpen: boolean;
  inputClientRect: DOMRect;
  ratingClientRect: DOMRect;
  target: any;
  popupTitle: string;
  qrEnabled: boolean;
  qrTitle: string;
  smsEnabled: boolean;
  smsTitle: string;
  smsText: string;
  rtl: boolean;
}) => {
  const { palette } = useTheme();
  const [phoneNumber, setPhoneNumber] = useState('');

  const mobileLink = useMemo(() => `${window.location.href.replace('kiosk', 'tour')}&target=${target.defaultSid}`, [target]);

  const handleMobileNumberChange = (value) => {
    setPhoneNumber(value);
  };

  const handleSendSms = async () => {
    const smsResult = await AdminAPI.sendNavigationLinkSms({ mobileLink, phoneNumber, smsText });
    if (smsResult?.message === 'Success.') {
      toast.success(rtl ? 'הודעת SMS נשלחה בהצלחה' : 'SMS sent successfully');
    } else {
      toast.error(rtl ? 'שגיאה בשליחת ההודעה' : 'Error sending message');
    }
    setPhoneNumber('');
  };

  return (
    <Modal
      // keepMounted
      open={isOpen}
      hideBackdrop
      sx={{
        maxWidth: '750px',
        height: 'fit-content',
        position: 'absolute',
        top: inputClientRect?.top + inputClientRect?.height + 10 + (ratingClientRect?.height || 0),
        left: 0,
        right: 0,
        mx: 'auto',
      }}
    >
      <Stack
        width="100%"
        sx={{
          borderRadius: '8px',
          border: '1px solid rgba(0, 0, 0, 0.10)',
          background: 'rgba(234, 236, 240, 0.85)',
          backdropFilter: 'blur(20px)',
          p: 0,
        }}
        flexWrap="wrap"
      >
        <Stack width="100%" alignItems="center" justifyContent="center" sx={{ backgroundColor: palette.treedis.blue.main, height: '55px', borderRadius: '8px 8px 0 0' }}>
          <Typography fontSize="20px" fontWeight={600} color="#fff">
            {popupTitle || 'Want to get the navigation guide to your phone?'}
          </Typography>
        </Stack>
        <Stack direction="row" width="100%" alignItems="flex-start" justifyContent="center" py="20px">
          {qrEnabled && (
            <Stack width="100%" alignItems="center" justifyContent="center" gap={2} sx={{ maxWidth: '254px' }}>
              <Typography fontSize="20px" fontWeight={600} height="60px" textAlign="center">
                {qrTitle || 'Scan the QR code to view on your phone '}
              </Typography>
              <Stack
                alignItems="center"
                justifyContent="center"
                sx={{
                  background: '#FFF',
                  padding: '10px',
                  borderRadius: '8px',
                }}
              >
                <img alt="qr" src={`https://api.qrserver.com/v1/create-qr-code/?size=166x166&data=${encodeURIComponent(mobileLink)}`} width="166px" height="166px" />
              </Stack>
            </Stack>
          )}
          {qrEnabled && smsEnabled && (
            <Divider
              orientation="vertical"
              flexItem
              sx={{
                '.MuiDivider-wrapper': {
                  transform: 'rotate(-90deg)',
                },
              }}
            >
              <Box
                component="span"
                sx={{
                  background: '#fff',
                  borderRadius: '10px',
                  padding: '3px 10px',
                }}
              >
                Or
              </Box>
            </Divider>
          )}
          {smsEnabled && (
            <Stack width="100%" alignItems="center" justifyContent="center" gap={2} sx={{ maxWidth: '414px' }}>
              <Typography fontSize="20px" fontWeight={600} height="60px">
                {smsTitle || rtl ? 'טלפון לקבלת לינק' : 'Fill your phone number to get link'}
              </Typography>
              <Stack sx={{ maxWidth: '372px', width: '100%', '.form-control': { width: '100% !important' } }}>
                <PhoneInput
                  country="il"
                  specialLabel=""
                  placeholder=""
                  value={phoneNumber}
                  onChange={handleMobileNumberChange}
                  // onlyCountries={['gr', 'fr', 'us', 'il', 'am', 'ua']}
                  inputStyle={{
                    height: '50px',
                    borderRadius: '8px',
                  }}
                />
              </Stack>
              <Button
                variant="contained"
                sx={{
                  maxWidth: '372px',
                  width: '100%',
                  height: '50px',
                  borderRadius: '8px',
                  background: palette.treedis.blue.main,
                  ':hover': {
                    background: palette.treedis.blue.main,
                  },
                  ':active': {
                    background: palette.treedis.blue.main,
                  },
                }}
                onClick={handleSendSms}
              >
                {rtl ? 'שלחו לי את הלינק' : 'Send me the link'}
              </Button>
            </Stack>
          )}
        </Stack>
      </Stack>
    </Modal>
  );
};
